import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback } from 'react';
import useCreateRecurlyMop from '../../../hooks/useCreateRecurlyMop';
import { doFireStatusUpdate } from '../../../utils/CallbackUtils';
import { PaymentMethodsCommandNames, StatusTypes } from '@chegg/commerce-utils';
import { Component } from '../../../constants/CallbackConstants';
export var useHandlePaymentAuthorized = function useHandlePaymentAuthorized() {
  var _useCreateRecurlyMop = useCreateRecurlyMop({
      token: '',
      isPrimary: true
    }),
    createRecurlyMopForTokenId = _useCreateRecurlyMop.createRecurlyMopForTokenId;
  return useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tokenId, isPrimary, country) {
      var _yield$createRecurlyM, _yield$createRecurlyM2, billingInfoId, billingAddress;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return createRecurlyMopForTokenId(tokenId, isPrimary);
          case 2:
            _yield$createRecurlyM = _context.sent;
            _yield$createRecurlyM2 = _yield$createRecurlyM.data.createMethodOfPayment;
            billingInfoId = _yield$createRecurlyM2.id;
            billingAddress = _yield$createRecurlyM2.billingAddress;
            delete billingAddress.__typename;
            doFireStatusUpdate([{
              status: StatusTypes.SUCCESS,
              command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD_ENABLED,
              payload: {
                component: Component.RECURLY_SERVICE,
                data: {
                  billingInfoId: billingInfoId,
                  billingAddress: billingAddress,
                  country: country
                }
              }
            }]);
            return _context.abrupt("return", {});
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(), [createRecurlyMopForTokenId]);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/business/processors/recurly/recurlyServiceHelpers.js
// module id = 664
// module chunks = 11